export default "__VITE_ASSET__7d377c4b__"